<template>
  <generic-page
    :image="mainImageUrl"
    image-height="95vh"
  >
    <v-card class="ma-5 pa-3">
      <v-card-title
        v-if="gydytojai.length > 0"
        class="px-0 pb-4 px-lg-2 px-xl-2 pt-1 pt-lg-3 pt-xl-3 primary--text"
      >
        <h2>{{ darbuotojaiPavadinimas }}</h2>
      </v-card-title>
      <v-card-text class="px-0 px-lg-2 px-xl-2">
        <v-row
          class="flex-column"
          no-gutters
        >
          <v-col
            v-if="gydytojai.length > 0"
          >
            <v-row
              v-for="gydytojas in gydytojai"
              :key="gydytojas.id"
              class="flex-colum flex-sm-row flex-md-row flex-lg-row flex-xl-row"
              no-gutters
            >
              <v-col
                :cols="isMobile() ? 12 : 3"
                class="pb-3"
              >
                <v-img
                  v-if="gydytojas.img.url"
                  :src="gydytojas.img.url"
                  :alt="gydytojas.img.alt"
                  aspect-ratio="1"
                  max-width="400px"
                  position="center center"
                  contain
                />
              </v-col>
              <v-col
                :cols="isMobile() ? 12 : 9"
                :class="isMobile() ? 'pl-0 pb-3' : 'pl-4 pb-3'"
              >
                <p class="headline primary--text">
                  {{ gydytojas.vardas }} {{ gydytojas.pavarde }}
                </p>
                <prismic-rich-text
                  v-if="gydytojas.aprasymas"
                  :field="gydytojas.aprasymas"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <h1 class="md-px-5 xs-px-1 py-5 primary--text">
              {{ content.title }}
            </h1>
            <prismic-rich-text
              v-if="content.body"
              :field="content.body"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </generic-page>
</template>

<script>
import genericPage from "../components/genericPage";

export default {
  name: "Home",
  components: { genericPage },
  data() {
    return {
      gydytojai: [],
      content: {
        title: "",
        body: []
      },
      darbuotojaiPavadinimas: '',
      page: 1,
      totalPages: 1
    };
  },
  computed: {
    mainImageUrl() {
      const elem = document.createElement("canvas");
      let canUseWebp = false;
      const environment = this.$vuetify.breakpoint.smAndDown
        ? "mobile"
        : "desktop";
      if (elem.getContext && elem.getContext("2d")) {
        canUseWebp = elem.toDataURL("image/webp").indexOf("image/webp") >= 0;
      }
      return require(`@/app/assets/img/main_${environment}.${
        canUseWebp ? "webp" : "png"
      }`);
    }
  },
  mounted() {
    this.getContent();
  },
  methods: {
    async getContent() {
      const { data } = await this.$prismic.client.getByUID(
        "puslapiai",
        "apie-mus"
      );
      const { data: gydytojai } = await this.$prismic.client.getByUID(
        "gydytojas",
        "darbuotojai"
      );
      this.darbuotojaiPavadinimas = gydytojai.pavadinimas[0].text
      const results = gydytojai.body

      this.gydytojai = results.map(({ primary }) => ({
        vardas: primary.vardas,
        pavarde: primary.pavarde,
        aprasymas: primary.aprasymas,
        img: primary.nuotrauka
      }));
      this.content = {
        ...this.content,
        title: data.pavadinimas[0].text,
        body: data.tekstas,
        img: this.isMobile()
          ? data.virsutinis_paveikslelis.mobile
          : data.virsutinis_paveikslelis
      };
    },
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    track() {
      this.$ga.page("/");
    }
  }
};
</script>

<style scoped>
</style>
